/**
 * meeting.ts
 * Secured Communications
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import moment from "moment-timezone";
import { Group } from "./group";


export const GUEST_STRING = "(Guest)"

export enum MeetingType {
  roundtable = "table",
  webinar = "wbnr"
}

export interface Meeting {
  _id: string,
  accountID: string,
  hostUserIDs: Array<string>,
  meetingname: string,
  meetingtype: MeetingType,
  autoAccept: boolean,
  sipEnabled: boolean,
  sipCode?: string,
  token: string,
  created: moment.Moment,

  // client-only
  group?: Group | null
}

export interface WaitingDevice {
  _id: string,
  accountID: string,
  meetingID: string,
  userID?: string,
  deviceID?: string,
  phoneNumber?: string,
  allowed: boolean,
  firstname: string,
  lastname: string
}